import React, { Component } from 'react';
import Header from "../Header/Header"
import Footer from "../Footer/Footer"
import ChairGraph from '../ChairGraph/ChairGraph';
import Miflagot from '../Miflagot/Miflagot';
import Parties from '../Parties/Parties';
import Popup from '../Popup/Popup';
import { Environment } from '../Services/Base';
import { interstitial } from '../Services/Adsense/ads';
import PopupError from '../Popup/PopupError';
import "./App.scss";
import { apiURL } from "../Services/Base.js";

export default class App extends Component {
  constructor() {
    super();
    this.state = {
      current: 0,
      count: 0,
      items: {},
      Comp: null,
      isBusy: false,
      isPopup: false,
      currentParty: {},
      partiesData:[],
      disclaimerTxt:""
    }
  }
  componentDidMount() {
    !Environment().isLocalhost ? interstitial() : null;
    this.getDisclaimer();
  }
  componentDidUpdate() {
    var count = 0;
    var timer = window.setTimeout(() => {
      window.clearTimeout(timer);
      for (let key in this.state.items) {
        count += this.state.items[key].Mandats;
      }
      if (count != this.state.count) {
        this.setState({
          count
        })
      }
    }, 60);
  }

  togglePopup = Comp => {
    if (this.state.isBusy) return;
    this.setState({
      isBusy: true,
    }, () => {
      this.setState({
        isBusy: false,
        Comp: Comp,
        isPopup: !this.state.isPopup
      })
    })
  }
  setCounter = item => {
    let { items } = this.state;
    items = {
      ...items,
      [item.index]: {
        ...items[item.index],
        Miflaga: item.name,
        Mandats: items && items[item.index] ?
          (items[item.index].Mandats == 0 ? item.mandats : 0) : item.mandats,
        EnglishName: item.englishName
      }
    }
    this.setState({
      items
    })
  }
  setPartiesData = data => {
    this.setState({
      partiesData: data
    })
  }

  setCurrentParty = (item) =>{
    this.setState({
      currentParty: item
    })
  }
  
  getDisclaimer = () => {
    fetch(`${apiURL}GetDisclaimerTextById/3`, {
        headers:{
        "Content-Type": "application/json"
    },
    method: "POST"
    
      }).then(response => response.json()).then(data => {
        this.setState({
            disclaimerTxt: data.Disclaimer
        });
      }).catch(e => console.log(e));
    }
  render() {
    return (
      <div className="App">
        <Header 
          currentParty={this.state.currentParty}/>
        <Popup
          Comp={this.state.Comp}
          showPopup={this.state.isPopup}
          togglePopup={this.togglePopup} />
          <div className="MainContainer">
            <Parties 
              partiesData = {this.state.partiesData} />
            <ChairGraph
              togglePopup={this.togglePopup}
              count={this.state.count} 
              partiesData = {this.state.partiesData}
              setCurrentParty = {this.setCurrentParty}
              currentParty={this.state.currentParty}
              disclaimerTxt = {this.state.disclaimerTxt}/>
            <Miflagot
              setCounter={this.setCounter}
              togglePopup={this.togglePopup} 
              setPartiesData = {this.setPartiesData}
              currentParty = {this.state.currentParty}
              logoPath = {this.state.currentParty.englishName != undefined ? `./Parties/${this.state.currentParty.englishName}/logo.png` : ""}
              darkLogoPath = {this.state.currentParty.englishName != undefined ? `./Parties/DarkMode/${this.state.currentParty.englishName}/logo.png` : ""}
              disclaimerTxt = {this.state.disclaimerTxt}
              />
          </div>
          {/* <Footer /> */}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Components/App/App.jsx